import * as actionTypes from './actionTypes';

const initialState = {
    // For fetching Mail
    count: 0,
    list: [],
    loading: false,
};

const fetchMailListStart = (state) => {
    return { ...state, loading: true };
};

const fetchMailListSuccess = (state, action) => {
    return {
        ...state,
        list: action.list,
        count: action.count,
        loading: false
    };
};

const fetchMailListFail = (state) => {
    return {
        ...state,
        loading: false
    };
};


const reducer = (state = initialState, action) => {
    switch (action.type) {
        // Fetching Mail
        case actionTypes.FETCH_MAIL_LIST_START:
            return fetchMailListStart(state, action);
        case actionTypes.FETCH_MAIL_LIST_SUCCESS:
            return fetchMailListSuccess(state, action);
        case actionTypes.FETCH_MAIL_LIST_FAIL:
            return fetchMailListFail(state, action);
        case 'CORE|LOGOUT_SUCCESS':
        case 'CORE|CORE_SET_ACTIVE_CUSTOMER_SUCCESS':
            return initialState;
        default:
            return state;
    }
};

export default reducer;
